import { BalanceValueCard } from "@/components/common/section-components/card/BalanceValueCard";
import { AccountCreditAgreement } from "../schema/account.schema";
import { HStack } from "@chakra-ui/react";
import { formatCurrency } from "@/utils/format-currency";

interface Props {
  creditAgreement?: AccountCreditAgreement | null;
}

export const CreditAgreementData = ({ creditAgreement }: Props) => {
  const hasCreditoVencido =
    creditAgreement?.creditoVencido !== null &&
    creditAgreement?.creditoVencido !== undefined;

  const hasCreditoTotal =
    creditAgreement?.creditoTotal !== null &&
    creditAgreement?.creditoTotal !== undefined;

  return (
    <HStack paddingTop="30px" gap="30px">
      <BalanceValueCard
        title="ACUERDO CRÉDITO VENCIDO"
        value={
          creditAgreement?.creditoVencido === null
            ? "-"
            : formatCurrency(creditAgreement?.creditoVencido)
        }
        noSign={!hasCreditoVencido}
      />
      <BalanceValueCard
        variant="contained"
        title="ACUERDO CRÉDITO TOTAL"
        value={
          creditAgreement?.creditoTotal === null
            ? "-"
            : formatCurrency(creditAgreement?.creditoTotal)
        }
        noSign={!hasCreditoTotal}
      />
    </HStack>
  );
};
